<template>
    <header>
        <div class="c-top-nav">
        </div>
        <nav class="o-container">
            <img class="logo" src="../assets/logo.png" />
            <div class="language-dropdown-container" ref="dropdownRef">
                <button
                    @click="toggleLanguageMenu"
                    class="language-trigger"
                    :aria-expanded="isLanguageMenuOpen"
                >
                    <Languages :size="24" />
                </button>
                <transition name="language-menu">
                    <div v-if="isLanguageMenuOpen" class="language-dropdown">
                        <a
                            v-for="lang in languages"
                            :key="lang.code"
                            @click="selectLanguage(lang.code)"
                            class="language-item"
                            :class="{ 'language-item--active': lang.code === i18n.locale.value }"
                        >
                            {{ lang.label }}
                        </a>
                    </div>
                </transition>
            </div>
        </nav>
    </header>
    <div class="c-main-layout">
        <router-view></router-view>
    </div>

    <footer></footer>
</template>

<style lang="scss" scoped>
a {
    cursor: pointer;
}

.language-dropdown-container {
    position: relative;
}

.language-trigger {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    color: #222;
    transition: opacity 150ms ease;

    &:hover {
        opacity: 0.7;
    }
}

.language-dropdown {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 100;
    min-width: 150px;
    overflow: hidden;
}

.language-item {
    display: block;
    padding: 0.75rem 1rem;
    cursor: pointer;
    text-decoration: none;
    color: #222;
    transition: background-color 150ms ease;

    &:hover {
        background-color: #f5f5f5;
    }

    &--active {
        font-weight: bold;
    }
}

// Slide-down animation
.language-menu-enter-active,
.language-menu-leave-active {
    transition: opacity 200ms ease, transform 200ms ease-out;
    transform-origin: top right;
}

.language-menu-enter-from,
.language-menu-leave-to {
    opacity: 0;
    transform: scaleY(0.92) translateY(-10px);
}

.language-menu-enter-to,
.language-menu-leave-from {
    opacity: 1;
    transform: scaleY(1) translateY(0);
}
</style>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { setI18nLanguage } from './i18n.js'
import { useI18n } from 'vue-i18n'
import { Languages } from 'lucide-vue-next'

const i18n = useI18n();

const isLanguageMenuOpen = ref(false);
const dropdownRef = ref(null);

const languages = [
    { code: 'nl', label: 'Nederlands' },
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' }
];

const toggleLanguageMenu = () => {
    isLanguageMenuOpen.value = !isLanguageMenuOpen.value;
}

const selectLanguage = async (locale) => {
    // Close menu first
    isLanguageMenuOpen.value = false;

    // Wait for transition to start
    await nextTick();

    // Then switch language
    setLocale(locale);
}

const setLocale = async (locale) => {
    setI18nLanguage(i18n, locale);
    localStorage.setItem("locale", locale);

    // set the location to /
    window.location.href = "/";
}

// Click outside detection
const handleClickOutside = (event) => {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        isLanguageMenuOpen.value = false;
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});

</script>